import { Routes, Route, Navigate } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";

// Components
import Contacts from "./components/dashboard/Contacts";
import Dashboard from "./components/dashboard/Dashboard";
import Messages from "./components/dashboard/Messages";
import Templates from "./components/dashboard/Templates";
import Faq from "./components/dashboard/Faq";
import Files from "./components/dashboard/Files";
import Ai from "./components/dashboard/Ai";
import Qualitas from "./components/qualitas/Qualitas";
import Profile from "./components/dashboard/Profile";
import WhatsApp from "./components/dashboard/WhatsApp";
import Subscription from "./components/dashboard/Subscription";
import Tutorials from "./components/dashboard/Tutorials";
import SignIn from "./components/auth/SignIn";
import SignUp from "./components/auth/SignUp";
import NotFound from "./components/main/NotFound";

// Context and Hooks
import { ColorModeContext, useMode } from "./theme";
import { useAuth } from "./contexts/AuthContext";

function App() {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          {/* Auth routes */}
          <Route path="/" element={<Navigate to="/signin" replace />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />

          {/* Protected dashboard route */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          >
            <Route index element={<WhatsApp />} />
            <Route path="messages" element={<Messages />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="templates" element={<Templates />} />
            <Route path="files" element={<Files />} />
            <Route path="ai" element={<Ai />} />
            <Route path="qualitas" element={<Qualitas />} />
            <Route path="profile" element={<Profile />} />
            <Route path="faq" element={<Faq />} />
            <Route path="whatsapp" element={<WhatsApp />} />
            <Route path="subscription" element={<Subscription />} />
            <Route path="tutorials" element={<Tutorials />} />
          </Route>

          {/* Not found route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

// Route protection
const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    return <Navigate to="/signin" replace />;
  }
  return children;
};

export default App;
